var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-center" }, [
    _c("i", {
      staticClass:
        "fad fa-spinner-third fa-spin aristotle-font-awesome-duotone",
    }),
    _vm._v("\n    " + _vm._s(_vm.loadingMessage) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }